import { z } from "zod";
import "../zod-runtime.js";
import { utilityPhysicsV2Schema } from "../physics/v2.js";
import { sideSchema, utilityTypeSchema, verificationStateSchema, workflowStatusSchema, } from "./enums.js";
import { pointSchema } from "./geometry.js";
import { mapSchema } from "./map.js";
import { mediaAssetSchema } from "./media.js";
export const utilityFrameSchema = z.object({
    kind: z.enum(["START", "AIM", "RESULT"]),
    label: z.string().min(1),
    media: mediaAssetSchema.nullable(),
    legacyPath: z.string().nullable().optional(),
});
export const utilitySchema = z.object({
    id: z.string().min(1),
    mapId: z.string().min(1),
    status: workflowStatusSchema,
    verificationState: verificationStateSchema,
    type: utilityTypeSchema,
    sides: z
        .array(sideSchema)
        .min(1)
        .max(2)
        .refine((sides) => new Set(sides).size === sides.length, {
        message: "Seiten dürfen nicht doppelt vorkommen.",
    })
        .default(["T", "CT"]),
    visibility: z.enum(["private", "team"]).default("team"),
    name: z.string().min(1),
    startCallout: z.string().min(1),
    targetCallout: z.string().min(1),
    technique: z.string().min(1),
    start: pointSchema,
    target: pointSchema,
    startLayerId: z.string().min(1).nullable().optional(),
    targetLayerId: z.string().min(1).nullable().optional(),
    arcHeight: z.number().min(-500).max(500).nullable().default(null),
    sourceNote: z.string().min(1),
    verifiedOn: z.string().date().nullable(),
    mapRevision: z.string().min(1),
    physics: utilityPhysicsV2Schema.nullable().optional(),
    frames: z.array(utilityFrameSchema).length(3),
    version: z.number().int().positive().default(1),
});
/** Katalogantwort ohne fremde Benutzer-IDs. */
export const catalogGrenadeSchema = utilitySchema.extend({
    ownedByCurrentUser: z.boolean(),
});
/**
 * Taktik, die Katalog-Granaten referenziert. Eigene Liste statt eines Felds
 * an der Granate: `POST`/`PUT /api/grenades` liefern eine einzelne Granate
 * zurück, ein Feld daran wäre nach jedem Speichern leer. `utilityIds` enthält
 * nur Granaten, die das Mitglied im Katalog sehen darf.
 */
export const catalogTacticRefSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    mapId: z.string().min(1),
    side: sideSchema,
    status: workflowStatusSchema,
    utilityIds: z.array(z.string().min(1)),
});
export const grenadeCatalogSchema = z.object({
    maps: z.array(mapSchema),
    grenades: z.array(catalogGrenadeSchema),
    tactics: z.array(catalogTacticRefSchema).default([]),
});
